module.exports = __webpack_public_path__ + "img/Agenda.a022a4cf.png";